import { useState, useEffect } from 'react';

export const useDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  // В оригинальном коде документы не загружались с сервера
  const loadDocuments = async () => {
    // Документы создаются только локально
    setIsLoading(false);
  };

  const createDocument = (name) => {
    const newDoc = {
      id: Date.now().toString(),
      name: name || 'Новый документ',
      created_at: new Date().toISOString(),
      data: {}
    };
    
    setDocuments(prev => [newDoc, ...prev]);
    setSelectedDoc(newDoc);
    
    return newDoc;
  };

  const updateDocument = (id, updates) => {
    setDocuments(prev => 
      prev.map(doc => 
        doc.id === id ? { ...doc, ...updates } : doc
      )
    );
    
    if (selectedDoc && selectedDoc.id === id) {
      setSelectedDoc(prev => ({ ...prev, ...updates }));
    }
  };

  const deleteDocument = (id) => {
    setDocuments(prev => prev.filter(doc => doc.id !== id));
    
    if (selectedDoc && selectedDoc.id === id) {
      setSelectedDoc(null);
    }
  };

  // Функция для установки выбранного документа
  const selectDocument = (doc) => {
    setSelectedDoc(doc);
  };

  useEffect(() => {
    loadDocuments();
  }, []);

  return {
    documents,
    selectedDoc,
    setSelectedDoc: selectDocument, // Используем нашу функцию с сохранением
    isLoading,
    error,
    loadDocuments,
    createDocument,
    updateDocument,
    deleteDocument
  };
};
